import PhoneInputComponent from './phoneInput';

export default PhoneInputComponent;
